<script lang="ts">
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import HomeSettingsLegacy from './HomeSettingsLegacy.svelte';
	import HomeSettingsV2 from './HomeSettingsV2.svelte';
</script>

{#if $showNewLayout}
	<HomeSettingsV2 />
{:else}
	<HomeSettingsLegacy />
{/if}
